(function(angular){
    'use strict';

    var inject = ['$scope', 'templateList', 'dmsToolbarButtonDepot', 'DmsToolbarButtonFactory', 'FlexGridSetUpService'];
    var controller = function($scope: any, templateList: any, dmsToolbarButtonDepot: any, DmsToolbarButtonFactory: any, FlexGridSetUpService: any) {

        var operationsSinceRefresh = 0;

        function refresh() {
            $scope.$broadcast('refresh-storage-grid');
            operationsSinceRefresh = 0;
        }

        $scope.$on('dmsItemRenamed', refresh);

        var buttons = dmsToolbarButtonDepot.buttons;
        $scope.buttons = [
            buttons.newTemplate,
            new DmsToolbarButtonFactory('manageDocs', /* i18nextract */'Bluemoon.DMS.Toolbar.FolderGrid.Manage','manage-dropdown').children([
                buttons.remove,
                buttons.properties,
                buttons.share
            ]).button()
        ];

        $scope.getGridItems = function() {
            return templateList.getGridItems($scope);
        };

        $scope.$on('dms-operation-complete', function(event: any, operationModel: any) {
            var op = operationModel.type;
            if (op === 'move' || op === 'copy' || op === 'add' || op === 'delete') {
                operationsSinceRefresh++;
                if (operationsSinceRefresh >= 5) {
                    refresh();
                }
            }
        });

        $scope.$on('dms-operation-batch-complete', function(){
            if (operationsSinceRefresh > 0) {
                refresh();
            }
        });

        $scope.container = {
            itemType: 'TemplatesList'
        };

        $scope.gridInitialized = function(grid: any) {
            $scope.gridColumns = grid.columns;
            FlexGridSetUpService.restoreColumnVisibility('folder-templates', grid);
        };

    };

    controller.$inject = inject;

    angular.module('onvio.documents')
        .controller('templateMaster', controller);

})((window as any).angular);
